var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppHeaderDropdown',{attrs:{"right":"","no-caret":""}},[_c('template',{slot:"header"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"img/user.png"}})]),_c('template',{slot:"dropdown"},[_c('app-trocar-senha')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }